import type * as SchemaTypes from '../types';

import type { TranslatedStringDataFragment } from './TranslatedStringData';
import { gql } from '@apollo/client';
import { TranslatedStringDataFragmentDoc } from './TranslatedStringData';
export type DealerDisclaimersFragmentFragment = (
  { __typename: 'DealerDisclaimers' }
  & { financingDisclaimer: Array<(
    { __typename: 'DealerFinancingDisclaimer' }
    & Pick<SchemaTypes.DealerFinancingDisclaimer, 'bankId' | 'bankName'>
    & { financingDisclaimer: (
      { __typename: 'TranslatedString' }
      & TranslatedStringDataFragment
    ) }
  )>, insuranceDisclaimer: Array<(
    { __typename: 'DealerInsuranceDisclaimer' }
    & Pick<SchemaTypes.DealerInsuranceDisclaimer, 'insurerId' | 'insurerName'>
    & { insuranceDisclaimer: (
      { __typename: 'TranslatedString' }
      & TranslatedStringDataFragment
    ) }
  )> }
);

export const DealerDisclaimersFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment DealerDisclaimersFragment on DealerDisclaimers {
  financingDisclaimer {
    bankId
    bankName
    financingDisclaimer {
      ...TranslatedStringData
    }
  }
  insuranceDisclaimer {
    insurerId
    insurerName
    insuranceDisclaimer {
      ...TranslatedStringData
    }
  }
}
    `;